"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntradayInterval = exports.InterdayInterval = void 0;
const types_1 = require("@refinitiv-data/types");
exports.InterdayInterval = types_1.HistoricalPricing.InterdayInterval;
exports.IntradayInterval = types_1.HistoricalPricing.IntradayInterval;
__exportStar(require("./definition"), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29udGVudC9oaXN0b3JpY2FsLXByaWNpbmcvc3VtbWFyaWVzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsaURBQTBEO0FBVTdDLFFBQUEsZ0JBQWdCLEdBQUcseUJBQWlCLENBQUMsZ0JBQWdCLENBQUM7QUFDdEQsUUFBQSxnQkFBZ0IsR0FBRyx5QkFBaUIsQ0FBQyxnQkFBZ0IsQ0FBQztBQUVuRSwrQ0FBNkIifQ==